export default "__VITE_ASSET__DAyHZaRc__"